module.exports = __webpack_public_path__ + "img/realestate.0375931d.jpg";